export default class extends Controller {
  connect() {
    this.replaceElementWith = this.replaceElementWith.bind(this)
    this.refreshElement = this.refreshElement.bind(this)
    App.Helpers.listenToCustomEvent(document, "default-schedule:shift", this.replaceElementMaybe)
    App.Helpers.listenToCustomEvent(document, "update-success", this.refreshElement)
  }

  replaceElementWith(response) {
    App.Helpers.replaceElement(this.element, response)
  }

  shift(event) {
    event && event.preventDefault()
    this.getElementReplacementFrom(event.currentTarget.href)
  }

  refreshElement(event) {
    const { updateType } = event.detail
    if (updateType == "default-schedule:add") {
      this.getElementReplacementFrom(this.refreshURL)
    }
  }

  getElementReplacementFrom(url) {
    App.Helpers.ajaxRequest({ url, successHandler: this.replaceElementWith })
  }

  get refreshURL() {
    return this.data.get("refresh-url")
  }
}



// WEBPACK FOOTER //
// ./app/components/users/default_user_availabilities/assets/javascript/users-default-user-availabilities-show-controller.js